import { AlertCircle } from 'lucide-react';

/**
 * A failure the form has nowhere else to put — a wrong password, a dead
 * connection, a 422 naming a field this screen does not render.
 *
 * `role="alert"` so it is announced when it appears: a submit button that
 * quietly stops spinning tells a screen-reader user nothing about why.
 * docs/05-ADMIN-DASHBOARD.md §6.3 — never a raw JSON error.
 */
export function FormError({ message }: { message: string | null | undefined }) {
  if (!message) {
    return null;
  }

  return (
    <p
      role="alert"
      /*
       * A tinted panel would want `bg-danger/10`, and there is no such colour:
       * `--danger` is a hex behind a CSS variable, so Tailwind emits nothing for
       * the modifier and the panel would be transparent. The preset test catches
       * this now. A rule down the inline edge does the same job with tokens that
       * exist, and `text-danger` is `--text-danger`, which clears AA on this
       * surface where `--danger` does not.
       */
      className="flex items-start gap-2 rounded-card border-s-4 border-danger bg-surface-alt p-3 text-body-sm text-danger"
    >
      <AlertCircle size={18} strokeWidth={1.75} aria-hidden="true" className="mt-0.5 shrink-0" />
      {message}
    </p>
  );
}
